<div class="sc-contribution-grid">
    <div
        class="my-3 mx-auto text-center"
        *ngIf="
            (!model?.rowsTop && !model?.rows) ||
            (model?.rowsTop?.length === 0 && model?.rows?.length === 0)
        "
    >
        {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
    </div>
    <div class="gridContainer">
        <div
            ngGrid
            [rendererOptions]="_rendererOpts"
            [selectTemplate]="_selectTpl"
            [rows]="model?.rows"
            [sortDefs]="model?.sortDefs"
            (willInflate)="_onWillInflate()"
            (didInflate)="_onDidInflate()"
            *ngIf="model?.rowsTop?.length !== 0 || model?.rows?.length !== 0"
            [rowsTop]="model?.rowsTop"
        >
            <ng-template
                gridContent
                data-type="grid"
            >
                <div></div>
            </ng-template>
            <ng-template
                gridContent
                data-type="row"
            >
                <div></div>
            </ng-template>
            <ng-template
                let-c="c"
                let-expanded="expanded"
                #sortTpl
            >
                <button class="align-self-end">
                    <cmps-icon
                        [class.cmps-cdk-fill-white]="!expanded"
                        [class.cmps-cdk-fill-black]="expanded"
                        [svgIcon]="
                            model?.sortDefs[0].order === _SortOrder.ASC
                                ? 'chevron-up'
                                : 'chevron-down'
                        "
                        *ngIf="
                            model?.sortDefs &&
                            model?.sortDefs.length &&
                            model?.sortDefs[0].columnId === c.id
                        "
                    ></cmps-icon>
                    <cmps-icon
                        [class.cmps-cdk-fill-white]="!expanded"
                        [class.cmps-cdk-fill-black]="expanded"
                        svgIcon="unfold-more-horizontal"
                        *ngIf="
                            !model?.sortDefs ||
                            !model?.sortDefs.length ||
                            model?.sortDefs[0].columnId !== c.id
                        "
                    ></cmps-icon>
                </button>
            </ng-template>
            <ng-template
                gridContent
                data-type="cell"
                data-id="headerGroup"
                let-c="c"
                let-ctx="ctx"
            >
                <div
                    [ngSwitch]="ctx.type"
                    class="justify-content-center align-items-center flex-wrap"
                >
                    <div class="sc-grid-table-header-content-group-pillar">
                        <span>{{ ctx.pillarName | translate }}</span>
                    </div>
                </div>
            </ng-template>
            <ng-template
                gridContent
                data-type="cell"
                data-id="header"
                let-c="c"
                let-ctx="ctx"
            >
                <div [ngSwitch]="ctx.type">
                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.SUPERGROUP_NAME"
                        [cmpsTooltipTrigger]="
                            _i18n._9117_SUPERGROUP_DESCRIPTION | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{ c.ctx.metricName | translate }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.USER_NAME"
                        [cmpsTooltipTrigger]="
                            _i18n._9116_DIRECTREPORTS_DESCRIPTION | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{ c.ctx.metricName | translate }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.PERIOD"
                        [cmpsTooltipTrigger]="
                            _i18n._9118_PERIOD_DESCRIPTION | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{ c.ctx.metricName | translate }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.ACTUAL"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{ ctx?.metricName }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                            <button
                                class="align-self-end"
                                (click)="_onExpandClick($event, c)"
                            >
                                <cmps-icon
                                    class="cmps-cdk-fill-white"
                                    [svgIcon]="
                                        c.ctx.isColumnExpanded
                                            ? 'arrow-collapse'
                                            : 'arrow-expand'
                                    "
                                ></cmps-icon>
                            </button>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header sc-grid-table-header-default"
                        [hidden]="c.hidden"
                        (click)="_onSortClick(c)"
                        *ngSwitchDefault
                    >
                        <span>{{ ctx?.metricName | translate }}</span>
                        <div
                            class="sc-grid-table-header-sorting-icon sc-grid-table-header-sorting-icon-expanded"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, expanded: true }
                                "
                            ></ng-container>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template
                gridContent
                data-type="cell"
                data-id="content"
                let-c="c"
                let-ctx="ctx"
            >
                <div [ngSwitch]="c.ctx.type">
                    <div
                        class="sc-grid-table-content-pillar"
                        *ngSwitchCase="_ColumnType.USER_NAME"
                    >
                        <div class="directReportCell">
                            <span>{{ ctx?.data[0].userName }}</span>
                            <cmps-icon
                                class="cell-icon"
                                svgIcon="open-in-new"
                                (click)="_onDRScorecardSelect(ctx.data[0])"
                                [cmpsTooltipTrigger]="
                                    _i18n._9980_LAUNCH_SCORECARD | translate
                                "
                                trigger="hover"
                            ></cmps-icon>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.SUPERGROUP_NAME"
                    >
                        <span>{{ ctx.data[0]?.superGroupName || '-' }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.PERIOD"
                    >
                        <span>{{
                            (ctx.data[0]?.period | cmpsGridPeriod) || '-'
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.ACTUAL"
                    >
                        <span>{{
                            _retrieveContributionCellData(
                                ctx?.data,
                                c.ctx.metricId
                            )
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.TARGET"
                    >
                        <span>{{
                            _retrieveContributionCellData(
                                ctx?.data,
                                c.ctx.metricId
                            )
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.TARGET_PERCENT"
                    >
                        <span
                            >{{
                                _retrieveContributionCellData(
                                    ctx?.data,
                                    c.ctx.metricId
                                )
                            }}%</span
                        >
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchDefault
                    >
                        <span>{{
                            _retrieveContributionCellData(
                                ctx?.data,
                                c.ctx.metricId
                            )
                        }}</span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
